import React from 'react'

import AppealsPage from './appeals-page'

export default function OurAppeals() {
    return <AppealsPage />
}
